import React from 'react';
import { Add, TextSnippet, GridView, ListAlt, Search, FilterList, SortByAlpha } from '../icons';
import ZoobbeSelect from '../Global/ZoobbeSelect';
import './scss/PageListHeader.scss';

const SORT_OPTIONS = [
  { value: 'lastOpened', label: 'Last opened' },
  { value: 'updated', label: 'Last edited' },
  { value: 'created', label: 'Created date' },
  { value: 'name', label: 'Name (A-Z)' }
];

const FILTER_OPTIONS = [
  { value: 'all', label: 'All pages' },
  { value: 'owned', label: 'Owned by me' },
  { value: 'shared', label: 'Shared with me' }
];

const PageListHeader = ({
  viewMode,
  setViewMode,
  sortBy,
  setSortBy,
  filterOwner,
  setFilterOwner,
  searchTerm,
  setSearchTerm,
  onCreatePage,
  isCreating,
  showArchived,
  setShowArchived
}) => {
  return (
    <div className="page-list-header-v2">
      {/* Top Section: Title & Primary Action */}
      <div className="header-top-bar">
        <div className="title-area">
          <div className="icon-badge">
            <TextSnippet size={24} />
          </div>
          <div className="text-content">
            <h1>Pages</h1>
            <p>Manage and organize your documents</p>
          </div>
        </div>
        
        <button className="primary-action-btn" onClick={onCreatePage} disabled={isCreating}>
          <Add size={20} />
          <span>{isCreating ? 'Creating…' : 'New Page'}</span>
        </button>
      </div>

      {/* Bottom Section: Toolbar (Search, Tabs, Filters) */}
      <div className="header-toolbar">
        <div className="left-controls">
          <div className="search-input-wrapper">
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Search pages..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button className="clear-btn" onClick={() => setSearchTerm('')}>✕</button>
            )}
          </div>

          <div className="view-tabs">
             <button 
              className={`tab ${!showArchived ? 'active' : ''}`}
              onClick={() => setShowArchived(false)}
            >
              Active
            </button>
            <button 
              className={`tab ${showArchived ? 'active' : ''}`}
              onClick={() => setShowArchived(true)}
            >
              Archived
            </button>
          </div>
        </div>

        <div className="right-controls">
          <div className="control-divider"></div>
          
          <div className="filter-group">
            <SortByAlpha size={18} className="group-icon" />
            <ZoobbeSelect
              options={SORT_OPTIONS}
              value={sortBy}
              onSelect={(option) => setSortBy(option.value)}
              className="header-select"
            />
          </div>

          <div className="filter-group">
            <FilterList size={18} className="group-icon" />
             <ZoobbeSelect
              options={FILTER_OPTIONS}
              value={filterOwner}
              onSelect={(option) => setFilterOwner(option.value)}
              className="header-select"
            />
          </div>

          <div className="view-toggle">
            <button 
              className={viewMode === 'list' ? 'active' : ''} 
              onClick={() => setViewMode('list')}
              title="List View"
            >
              <ListAlt size={18} />
            </button>
            <button 
              className={viewMode === 'grid' ? 'active' : ''} 
              onClick={() => setViewMode('grid')}
              title="Grid View"
            >
              <GridView size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageListHeader;
